import React from 'react';
import Statistic from '../../components/Statistic';


const Dashboard = () => {
 

  return (
  <>
     <Statistic/>
  </>
  );
};

export default Dashboard;
